import React from 'react';

import { SvgIcon } from 'components/icons/SvgIcon';

type Props = {
  isOver?: boolean;
};

export const Trash: React.FC<Props> = (props) => (
  <div className={`trash ${props.isOver ? 'trash--over' : ''}`}>
    <SvgIcon
      icon={props.isOver ? 'trash-open' : 'trash'}
      className='translate-into-middle'
      style={{ fontSize: '28px' }}
    />
    <div className='trash__tip key-value'>
      <span className='icon-up' />
      &nbsp; Drop here to remove
    </div>
  </div>
);
